import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";
import {
  FaMinus,
  FaPlus,
  FaClock,
  FaTag,
  FaStar,
  FaFire,
  FaBolt,
  FaShoppingCart,
  FaTrash,
  FaChevronDown,
  FaStore,
  FaCheck,
  FaShoppingBag,
  FaEye,
  FaChevronLeft,
} from "react-icons/fa";
import {
  decrementSalonHomeCart,
  getSalonHomeCartTotal,
  setSelectedSalonHomeCategory,
  addToSalonHomeCartBackend,
  removeFromSalonHomeCartBackend,
  updateSalonHomeCartItemBackend,
  addtoSalonHomeCart,
  removefromSalonHomeCart,
  clearSalonHomeCart,
} from "../../redux/cart/HomeSalon";

const SubcatPageDesk = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get category data from navigation state
  const categoryData = location.state;

  const {
    salonHomeSelectedCategory,
    salonHomeNetPayable,
    salonHomeCartTotalMrp,
    salonHomeCartItems,
    loading,
    error,
  } = useSelector((state) => state.HomeSalonCart);

  const [singleCat, setSingleCat] = useState(categoryData || null);
  const [currentSubcatbyCat, setCurrentSubcatbyCat] = useState([]);
  const [defaultSubcat, setDefaultSubcat] = useState("");
  const [temploading, setTempLoading] = useState(true);
  const [tagsbySubcat, setTagsbySubcat] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [catTagLoading, setCatTagLoading] = useState(true);
  const [showProducts, setShowProducts] = useState([]);
  const [prodTempLoading, setProdTempLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [slideIn, setSlideIn] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [mobileModalVisible, setMobileModalVisible] = useState(false);
  const [selectedMobileProduct, setSelectedMobileProduct] = useState(null);
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [selectedProductServices, setSelectedProductServices] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState("");

  // Fetch subcategories when category data is available
  useEffect(() => {
    if (categoryData && categoryData._id) {
      setSingleCat(categoryData);
      fetchSubcategories(categoryData._id);
    } else {
      setErrorMessage(
        "No category data found. Please go back and select a category."
      );
      setTempLoading(false);
    }
  }, [categoryData]);

  const fetchSubcategories = async (categoryId) => {
    try {
      const url = `${Baseurl}/api/v1/subcategory/subcategoryid/${categoryId}`;
      const response = await axios.get(url);
      if (response.data.success === true) {
        const prod = response.data.subcategory;

        if (prod.length > 0) {
          setDefaultSubcat(prod[0]);
          setCurrentSubcatbyCat(prod);
          setTempLoading(false);
        } else {
          setErrorMessage("No subcategories found for this category.");
          setTempLoading(false);
        }
      } else {
        setErrorMessage("Failed to load subcategories.");
        setTempLoading(false);
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      setErrorMessage("Error loading subcategories. Please try again.");
      setTempLoading(false);
    }
  };

  // Fetch tags when default subcategory changes
  useEffect(() => {
    if (defaultSubcat && defaultSubcat._id) {
      const fetchData = async () => {
        try {
          const url = `${Baseurl}/api/v1/categorytag/tagsbysubcat/${defaultSubcat._id}`;
          const fetchproducts = await axios.get(url);

          if (fetchproducts.data.success === true) {
            const prod = fetchproducts.data.tags;
            setTagsbySubcat(prod);
            setSelectedTag(prod[0]);
            setCatTagLoading(false);
          }
        } catch (error) {
          console.error("Error fetching tags:", error);
          setCatTagLoading(false);
        }
      };

      fetchData();
    }
  }, [defaultSubcat]);

  // Fetch products when selected tag or cart items change
  useEffect(() => {
    if (selectedTag && selectedTag._id) {
      const getproducts = async () => {
        try {
          const url = `${Baseurl}/api/v1/product/productbyCatTagid/${selectedTag._id}`;
          const fetchproducts = await axios(url);

          if (fetchproducts.data.success === true) {
            const prod = fetchproducts.data.product.filter(
              (data) => data.outOfStock === false
            );

            let productbySubcat = prod.map((product) => ({
              ...product,
              cartQuantity: 0,
            }));

            // Update cart quantities from Redux store
            salonHomeCartItems.forEach((cartitem) => {
              const itemIndex = productbySubcat.findIndex(
                (product) => product._id === cartitem.ProductId
              );
              if (itemIndex >= 0) {
                productbySubcat[itemIndex].cartQuantity = cartitem.Qty;
              }
            });

            setShowProducts(productbySubcat);
            setProdTempLoading(false);
            setIsVisible(true);
            setSlideIn(true);
          }
        } catch (error) {
          console.error("Error fetching products:", error);
          setProdTempLoading(false);
        }
      };

      getproducts();
    }
  }, [selectedTag, salonHomeCartItems]);

  // Modal functions
  const handleShowMoreServices = (product) => {
    setSelectedProductServices(product.services || []);
    setSelectedProductName(product.name || product.ItemName);
    setShowServicesModal(true);
  };

  const handleCloseServicesModal = () => {
    setShowServicesModal(false);
    setSelectedProductServices([]);
    setSelectedProductName("");
  };

  const handleMobileProductPress = (product) => {
    setSelectedMobileProduct(product);
    setMobileModalVisible(true);
  };

  const handleCloseMobileModal = () => {
    setMobileModalVisible(false);
    setSelectedMobileProduct(null);
  };

  const subcatChange = (subcat) => {
    setDefaultSubcat(subcat);
    setIsVisible(false);
    setSlideIn(false);
    setTimeout(() => {
      setIsVisible(true);
      setSlideIn(true);
    }, 50);
  };

  const changeTagProduct = (tag) => {
    setSelectedTag(tag);
    setIsVisible(false);
    setSlideIn(false);
    setTimeout(() => {
      setIsVisible(true);
      setSlideIn(true);
    }, 50);
  };

  const addToCartPress = async (product, index) => {
    try {
      if (
        salonHomeSelectedCategory === product.category ||
        salonHomeSelectedCategory === ""
      ) {
        if (salonHomeSelectedCategory === "") {
          dispatch(setSelectedSalonHomeCategory(product.category));
        }

        // Immediate UI update
        let products = [...showProducts];
        products[index].cartQuantity = products[index].cartQuantity + 1;
        setShowProducts(products);

        // Fix the Services array structure
        const fixedServices = (product.services || []).map((service) => ({
          service: service.service || "",
          duration: service.duration || product.duration || "30 mins",
          price: service.price || product.sellingPrice || 0,
          _id: service._id,
        }));

        const formData = {
          ProductId: product._id,
          ProductName: product.name,
          CatId: product.categoryId,
          CatName: product.category,
          Brand: product.brand || "Default Brand",
          Services: fixedServices,
          Duration: product.duration || "30 mins",
          ImgUrl: product.ImgUrlMbl || product.ImgUrlDesk || "default-image",
          Price: product.sellingPrice,
          Qty: 1,
          TotalAmount: product.sellingPrice * 1,
          Mrp: product.mrp,
          TotalPrice: product.sellingPrice * 1,
          TotalMrp: product.mrp * 1,
          Discount: product.mrp * 1 - product.sellingPrice * 1,
          productCostPrice: product.productCostPrice || product.sellingPrice,
          for: "homeSaloon",
          clientId: "65d8f5a8e4b3a1c7f8a9b123",
        };

        // Local update for immediate UI response
        dispatch(addtoSalonHomeCart(formData));

        // Backend sync using Redux async thunk
        await dispatch(addToSalonHomeCartBackend(formData)).unwrap();

        dispatch(getSalonHomeCartTotal());
      } else {
        // Handle category change logic...
        dispatch(setSelectedSalonHomeCategory(product.category));
        dispatch(clearSalonHomeCart());

        // Immediate UI update
        let products = [...showProducts];
        products[index].cartQuantity = products[index].cartQuantity + 1;
        setShowProducts(products);

        const fixedServices = (product.services || []).map((service) => ({
          service: service.service || "",
          duration: service.duration || product.duration || "30 mins",
          price: service.price || product.sellingPrice || 0,
          _id: service._id,
        }));

        const formData = {
          ProductId: product._id,
          ProductName: product.name,
          CatId: product.categoryId,
          CatName: product.category,
          Brand: product.brand || "Default Brand",
          Services: fixedServices,
          Duration: product.duration || "30 mins",
          ImgUrl: product.ImgUrlMbl || product.ImgUrlDesk || "default-image",
          Price: product.sellingPrice,
          Qty: 1,
          TotalAmount: product.sellingPrice * 1,
          Mrp: product.mrp,
          TotalPrice: product.sellingPrice * 1,
          TotalMrp: product.mrp * 1,
          Discount: product.mrp * 1 - product.sellingPrice * 1,
          productCostPrice: product.productCostPrice || product.sellingPrice,
          for: "homeSaloon",
          clientId: "65d8f5a8e4b3a1c7f8a9b123",
        };

        dispatch(addtoSalonHomeCart(formData));

        // Backend sync using Redux async thunk
        await dispatch(addToSalonHomeCartBackend(formData)).unwrap();

        dispatch(getSalonHomeCartTotal());
      }
    } catch (error) {
      console.error("Failed to add to salon home cart:", error);

      // Rollback UI update on error
      let products = [...showProducts];
      products[index].cartQuantity = products[index].cartQuantity - 1;
      setShowProducts(products);
    }
  };

  const handleRemoveFromCart = async (productId) => {
    try {
      // Find the product in showProducts to update local UI
      const productIndex = showProducts.findIndex(
        (product) => product._id === productId
      );

      if (productIndex !== -1) {
        // Update local UI state
        const updatedProducts = [...showProducts];
        updatedProducts[productIndex].cartQuantity = 0;
        setShowProducts(updatedProducts);
      }

      // Dispatch local removal for immediate UI update
      dispatch(removefromSalonHomeCart({ ProductId: productId }));

      // Call backend to remove item
      await dispatch(removeFromSalonHomeCartBackend(productId)).unwrap();

      // Recalculate cart totals
      dispatch(getSalonHomeCartTotal());
    } catch (error) {
      console.error("Failed to remove from salon home cart:", error);
      // You might want to show an error message to the user here
    }
  };
  const decrementCartPress = async (product, index) => {
    try {
      // Immediate UI update
      let products = [...showProducts];
      if (products[index].cartQuantity > 0) {
        products[index].cartQuantity = products[index].cartQuantity - 1;
        setShowProducts(products);
      }

      const formData = {
        ProductId: product._id,
        ProductName: product.name,
        CatId: product.categoryId,
        CatName: product.category,
        Brand: product.brand,
        Services: product.services,
        Duration: product.duration,
        ImgUrl: product.ImgUrlMbl,
        Price: product.sellingPrice,
        Qty: 1,
        TotalAmount: product.sellingPrice * 1,
        Mrp: product.mrp,
        TotalPrice: product.sellingPrice * 1,
        TotalMrp: product.mrp * 1,
        Discount: product.mrp * 1 - product.sellingPrice * 1,
        productCostPrice: product.productCostPrice,
      };

      // Local update for immediate UI response
      dispatch(decrementSalonHomeCart(formData));

      // If quantity becomes 0, remove from backend
      const currentItem = salonHomeCartItems.find(
        (item) => item.ProductId === product._id
      );
      if (currentItem && currentItem.Qty === 1) {
        await dispatch(removeFromSalonHomeCartBackend(product._id)).unwrap();
      } else {
        // Update quantity in backend
        const newQuantity = currentItem ? currentItem.Qty - 1 : 0;
        if (newQuantity > 0) {
          await dispatch(
            updateSalonHomeCartItemBackend({
              productId: product._id,
              quantity: newQuantity,
            })
          ).unwrap();
        }
      }

      dispatch(getSalonHomeCartTotal());
    } catch (error) {
      console.error("Failed to decrement salon home cart:", error);
    }
  };

  const formatDuration = (duration) => {
    if (!duration) return "30 mins";
    return duration.includes("min") ? duration : `${duration} mins`;
  };

  // Loading State
  if (temploading) {
    return (
      <div className="container-fluid p-0 bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div
            className="spinner-border text-primary"
            style={{ width: "3rem", height: "3rem" }}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading category data...</p>
        </div>
      </div>
    );
  }

  // Error State
  if (errorMessage || !singleCat) {
    return (
      <div className="container-fluid p-0 bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center p-5">
          <div className="alert alert-warning" role="alert">
            {errorMessage || "Category data not found"}
          </div>
          <button
            className="btn btn-primary mt-3 px-4 py-2"
            onClick={() => navigate(-1)}
          >
            <FaChevronLeft className="me-2" />
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // Main Content
  return (
    <div
      className="py-4 px-md-3 px-2"
      style={{ minHeight: "100vh", marginTop: "70px" }}
    >
      <div className="row">
        {/* LEFT SECTION - Subcategories (Design 1 Categories Style) */}
        <div className="col-xl-2.5 col-lg-3 col-md-4 col-4 mb-4">
          <div className="border-0 rounded  bg-white p-3">
            {currentSubcatbyCat.length > 0 ? (
              <div className="row row-cols-1 row-cols-md-3 g-3">
                {currentSubcatbyCat.map((subcat, index) => (
                  <div
                    key={index}
                    className="col text-center cursor-pointer"
                    onClick={() => subcatChange(subcat)}
                  >
                    <img
                      src={subcat.desktopImage}
                      alt={subcat.name}
                      className={`img-fluid rounded ${
                        defaultSubcat?._id === subcat._id
                          ? "border border-primary"
                          : ""
                      }`}
                      style={{
                        width: "65px",
                        height: "65px",
                        objectFit: "cover",
                      }}
                    />
                    <p className="mt-2 small fw-medium text-truncate">
                      {subcat.name}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-3">
                <p className="text-muted">No subcategories available</p>
              </div>
            )}
          </div>
        </div>

        {/* CENTER SECTION - Products (Design 1 Services Style) */}
        <div className="col-xl-6 col-lg-6 col-md-8 col-8 mb-4 d-none d-md-block">
          {/* Tags Section */}
          <div className="border-0 rounded bg-white p-3">
            <div
              className="d-flex gap-2 overflow-auto flex-nowrap"
              style={{ whiteSpace: "nowrap" }}
            >
              {tagsbySubcat.map((tags, tagIndex) => (
                <button
                  key={tagIndex}
                  className={`btn btn-sm rounded-pill ${
                    tags._id === selectedTag?._id
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => changeTagProduct(tags)}
                >
                  {tags.name}
                </button>
              ))}
            </div>
          </div>

          {prodTempLoading ? (
            <div className="text-left py-5">
              <div className="spinner-border text-primary"></div>
            </div>
          ) : showProducts?.length > 0 ? (
            <div className="row g-3 border-0 mt-1">
              {showProducts.map((product, index) => (
                <div key={index} className="col-12 bg-white">
                  <div className="p-1 border-0 rounded h-100">
                    <div className="row align-items-start">
                      {/* Image */}
                      <div className="col-md-3 mb-3 mb-md-0">
                        <img
                          src={product.ImgUrlDesk || product.ImgUrlMbl}
                          alt={product.name}
                          className="img-fluid rounded"
                          style={{
                            height: "150px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      {/* Details */}
                      <div className="col-md-6 mb-3 mb-md-0 text-start">
                        <h5 className="fw-bold">{product.name}</h5>

                        <div className="d-flex gap-2 mb-2">
                          <span className="badge bg-success">SERVICE</span>
                          <span className="text-muted small">
                            {formatDuration(product.duration)}
                          </span>
                        </div>

                        <h5>
                          ₹{product.sellingPrice}
                          <span className="text-decoration-line-through text-muted ms-2">
                            ₹{product.mrp}
                          </span>
                          <span className="ms-2 text-success small">
                            {Math.round(
                              ((product.mrp - product.sellingPrice) /
                                product.mrp) *
                                100
                            )}
                            % OFF
                          </span>
                        </h5>

                        <ul className="small mb-0">
                          {product.services?.slice(0, 1).map((s, i) => (
                            <li key={i}>
                              <strong>{s.service.split(":")[0]}:</strong>{" "}
                              {s.service.split(":")[1]}
                            </li>
                          ))}

                          {product.services?.length > 1 && (
                            <li>
                              <button
                                onClick={() => handleShowMoreServices(product)}
                                className="btn btn-link p-0 small"
                              >
                                +{product.services.length - 1} more services
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>

                      {/* Cart Controls */}
                      <div className="col-md-3">
                        <div className="d-flex flex-column align-items-center">
                          {product.cartQuantity > 0 ? (
                            <>
                              <div className="bg-light rounded-pill px-3 py-2 mb-2">
                                <div className="d-flex align-items-center gap-2">
                                  <button
                                    onClick={() =>
                                      decrementCartPress(product, index)
                                    }
                                    className="btn btn-outline-dark btn-sm rounded-circle"
                                  >
                                    <FaMinus size={12} />
                                  </button>
                                  <span className="fw-bold">
                                    {product.cartQuantity}
                                  </span>
                                  <button
                                    onClick={() =>
                                      addToCartPress(product, index)
                                    }
                                    className="btn btn-outline-dark btn-sm rounded-circle"
                                  >
                                    <FaPlus size={12} />
                                  </button>
                                </div>
                              </div>
                              <span className="fw-bold text-success">
                                ₹{product.sellingPrice * product.cartQuantity}
                              </span>
                            </>
                          ) : (
                            <button
                              onClick={() => addToCartPress(product, index)}
                              className="btn btn-outline-dark w-100 rounded-pill"
                            >
                              ADD TO CART
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <h4>No Products Found</h4>
            </div>
          )}
        </div>

        {/* CENTER SECTION - Products mobile */}
        <div className="col-8 mb-3 d-block d-md-none">
          {prodTempLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary"></div>
            </div>
          ) : showProducts?.length > 0 ? (
            <div className="row g-3">
              {showProducts.map((product, index) => (
                <div key={index} className="col-12">
                  <div
                    className="p-3 rounded bg-white"
                    onClick={() => handleMobileProductPress(product)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-start">
                      {/* Left - Image */}
                      <div className="flex-shrink-0 me-3">
                        <img
                          src={product.ImgUrlMbl || product.ImgUrlDesk}
                          alt={product.name}
                          className="img-fluid rounded"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      {/* Right - Content */}
                      <div className="flex-grow-1 text-start">
                        <h6 className="fw-bold mb-1">{product.name}</h6>

                        <div className="d-flex gap-2 mb-1">
                          <span className="badge bg-success small">
                            SERVICE
                          </span>
                          <span className="text-muted small">
                            {formatDuration(product.duration)}
                          </span>
                        </div>

                        <h6 className="fw-semibold mb-1">
                          ₹{product.sellingPrice}
                          <span className="text-decoration-line-through text-muted ms-2 small">
                            ₹{product.mrp}
                          </span>
                          <span className="ms-2 text-success small">
                            {Math.round(
                              ((product.mrp - product.sellingPrice) /
                                product.mrp) *
                                100
                            )}
                            % OFF
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <h6>No Products Found</h6>
            </div>
          )}
        </div>

        {/* RIGHT SECTION - Cart (Design 1 Cart Box Style) */}
        <div className="col-xl-3 col-lg-3 d-none d-lg-block">
          <div className="border-0 rounded p-4 text-center mb-4 bg-white">
            {salonHomeCartItems.length === 0 ? (
              <div className="border-0 rounded p-4 text-center bg-white">
                <FaShoppingBag className="fs-1 text-muted" />
                <p className="mt-3 text-muted">No items in your cart</p>
              </div>
            ) : (
              <>
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  {salonHomeCartItems.map((cart, index) => (
                    <div
                      key={index}
                      className="border-0 rounded p-3 bg-white mb-3"
                    >
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h6 className="fw-bold text-dark mb-0 flex-grow-1 me-3">
                          {cart.ProductName}
                        </h6>
                        <button
                          onClick={() => handleRemoveFromCart(cart.ProductId)}
                          className="btn btn-link text-danger p-0 border-0"
                        >
                          <FaTrash className="small" />
                        </button>
                      </div>

                      <div className="row">
                        <div className="col-8">
                          <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                              <span className="h6 fw-bold text-dark mb-0">
                                ₹{cart.Price}
                              </span>
                              <span className="text-muted text-decoration-line-through small">
                                ₹{cart.Mrp}
                              </span>
                              <span className="badge bg-success small">
                                {(
                                  ((cart.Mrp - cart.Price) / cart.Mrp) *
                                  100
                                ).toFixed(0)}
                                % OFF
                              </span>
                            </div>
                            <div className="d-flex align-items-center bg-light px-2 py-1 rounded">
                              <FaClock className="text-muted me-1 small" />
                              <small className="text-muted fw-semibold">
                                {cart.Duration}
                              </small>
                            </div>
                          </div>

                          <div className="mb-2">
                            {cart.Services?.slice(0, 2).map(
                              (indService, serviceIndex) => (
                                <div
                                  key={serviceIndex}
                                  className="d-flex align-items-start mb-1"
                                >
                                  <FaCheck className="text-success me-2 mt-1 small" />
                                  <small className="text-muted">
                                    {indService.service &&
                                    indService.service.length > 50
                                      ? `${indService.service.slice(0, 50)}...`
                                      : indService.service}
                                  </small>
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        <div className="col-4 text-end">
                          <img
                            src={cart.ImgUrl}
                            alt={cart.ProductName}
                            className="img-fluid rounded"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center pt-2 border-0">
                        <div className="d-flex align-items-center">
                          <span className="text-muted me-2 small fw-semibold">
                            Quantity:
                          </span>
                          <span className="fw-bold">{cart.Qty}</span>
                        </div>
                        <span className="fw-bold text-dark small">
                          Item Total: ₹{cart.TotalAmount}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="border-0 pt-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted fw-semibold">
                      Subtotal ({salonHomeCartItems.length}{" "}
                      {salonHomeCartItems.length === 1 ? "item" : "items"})
                    </span>
                    <span className="h6 fw-bold text-dark mb-0">
                      ₹{salonHomeNetPayable || 0}
                    </span>
                  </div>

                  {salonHomeCartTotalMrp - salonHomeNetPayable > 0 && (
                    <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-success bg-opacity-10 rounded">
                      <span className="text-success fw-semibold small">
                        You save
                      </span>
                      <span className="fw-bold text-success small">
                        ₹{salonHomeCartTotalMrp - salonHomeNetPayable}
                      </span>
                    </div>
                  )}

                  <div className="text-center text-muted small mb-3">
                    Extra charges may apply
                  </div>

                  {/* Coupon Section */}
                  <div className="border-0 rounded p-3 bg-white mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <FaTag className="text-success" />
                      <span>Apply Coupon</span>
                    </div>
                    <p className="small text-muted mb-1">
                      Get discounts on your booking
                    </p>
                    <p className="small fw-semibold text-primary mb-0">
                      View More Offers ▼
                    </p>
                  </div>

                  <button
                    onClick={() => navigate("/cart")}
                    className="btn w-100 border-0"
                    style={{ backgroundColor: "#b93c5b", color: "#fff" }}
                  >
                    PROCEED TO CART - ₹{salonHomeNetPayable || 0}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Cart Footer - Mobile Only (Design 1 Style) */}
      {salonHomeCartItems.length > 0 && (
        <div className="fixed-bottom bg-white border-0  d-lg-none">
          <div className="container-fluid">
            <div className="row align-items-center py-2">
              {/* Cart Icon and Count */}
              <div className="col-3">
                <div className="position-relative d-inline-block ms-1">
                  <FaShoppingCart className="text-primary fs-4" />
                  {salonHomeCartItems.length > 0 && (
                    <span
                      className="position-absolute translate-middle badge rounded-pill bg-danger"
                      style={{
                        top: "-2px",
                        right: "-14px",
                        fontSize: "10px",
                        padding: "4px 6px",
                      }}
                    >
                      {salonHomeCartItems.length}
                    </span>
                  )}
                </div>
              </div>

              {/* Total Amount */}
              <div className="col-5">
                <div className="text-start">
                  <div className="fw-bold fs-6">
                    ₹{salonHomeNetPayable || 0}
                  </div>
                  <small className="text-muted">
                    {salonHomeCartItems.length}{" "}
                    {salonHomeCartItems.length === 1 ? "item" : "items"}
                  </small>
                </div>
              </div>

              {/* View Cart Button */}
              <div className="col-4 py-1">
                <button
                  onClick={() => navigate("/salon-cart")}
                  className="btn w-100 border-0 py-1"
                  style={{ backgroundColor: "#b93c5b", color: "#fff" }}
                >
                  View Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Modal (Design 1 Style) */}
      {showServicesModal && (
        <div
          className="modal show d-block text-start"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleCloseServicesModal}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg text-start"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content text-start">
              <div className="modal-header border-bottom-0">
                <h5 className="modal-title fw-bold">
                  All Services Included - {selectedProductName}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseServicesModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="list-group">
                  {selectedProductServices.map((service, index) => (
                    <div
                      key={index}
                      className="list-group-item border-0 px-0 py-2"
                    >
                      <div className="d-flex align-items-start text-start">
                        <FaCheck className="text-success me-2 mt-1 flex-shrink-0" />
                        <div className="flex-grow-1">
                          <strong className="d-block">
                            {service.service.split(":")[0]}:
                          </strong>
                          <span className="text-muted">
                            {service.service.split(":")[1] || service.service}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseServicesModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Product Modal (Design 1 Style) */}
      {mobileModalVisible && selectedMobileProduct && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleCloseMobileModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header border-bottom-0">
                <h5 className="modal-title fw-bold">
                  {selectedMobileProduct.name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseMobileModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="text-left mb-3">
                  <img
                    src={
                      selectedMobileProduct.ImgUrlMbl ||
                      selectedMobileProduct.ImgUrlDesk
                    }
                    alt={selectedMobileProduct.name}
                    className="img-fluid rounded"
                    style={{
                      height: "200px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div className="d-flex gap-2 mb-2">
                  <span className="badge bg-success">SERVICE</span>
                  <span className="text-muted small">
                    {formatDuration(selectedMobileProduct.duration)}
                  </span>
                </div>

                <h4 className="mb-3 text-start">
                  ₹{selectedMobileProduct.sellingPrice}
                  <span className="text-decoration-line-through text-muted ms-2">
                    ₹{selectedMobileProduct.mrp}
                  </span>
                  <span className="ms-2 text-success small">
                    {Math.round(
                      ((selectedMobileProduct.mrp -
                        selectedMobileProduct.sellingPrice) /
                        selectedMobileProduct.mrp) *
                        100
                    )}
                    % OFF
                  </span>
                </h4>

                <div className="mb-3 text-start">
                  <h6 className="fw-bold">Services Included:</h6>
                  <ul className="small">
                    {selectedMobileProduct.services?.map((service, index) => (
                      <li key={index} className="mb-2">
                        <strong>{service.service.split(":")[0]}:</strong>{" "}
                        {service.service.split(":")[1] || service.service}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="modal-footer border-top-0">
                <div className="w-100">
                  {selectedMobileProduct.cartQuantity > 0 ? (
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="bg-light rounded-pill px-3 py-2">
                        <div className="d-flex align-items-center gap-3">
                          <button
                            onClick={() => {
                              const index = showProducts.findIndex(
                                (item) => item._id === selectedMobileProduct._id
                              );
                              if (index !== -1) {
                                decrementCartPress(
                                  selectedMobileProduct,
                                  index
                                );
                              }
                            }}
                            className="btn btn-outline-dark btn-sm rounded-circle"
                          >
                            <FaMinus size={12} />
                          </button>
                          <span className="fw-bold">
                            {selectedMobileProduct.cartQuantity}
                          </span>
                          <button
                            onClick={() => {
                              const index = showProducts.findIndex(
                                (item) => item._id === selectedMobileProduct._id
                              );
                              if (index !== -1) {
                                addToCartPress(selectedMobileProduct, index);
                              }
                            }}
                            className="btn btn-outline-dark btn-sm rounded-circle"
                          >
                            <FaPlus size={12} />
                          </button>
                        </div>
                      </div>
                      <span className="fw-bold text-success">
                        ₹
                        {selectedMobileProduct.sellingPrice *
                          selectedMobileProduct.cartQuantity}
                      </span>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        const index = showProducts.findIndex(
                          (item) => item._id === selectedMobileProduct._id
                        );
                        if (index !== -1) {
                          addToCartPress(selectedMobileProduct, index);
                          handleCloseMobileModal();
                        }
                      }}
                      className="btn btn-outline-dark w-100 rounded-pill py-2"
                    >
                      ADD TO CART
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubcatPageDesk;
